import Layout from '../views/Layout.vue'
export default {
  path: '/school',
  name: '装备配备',
  component: Layout,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: true,
  children: [
    {
      path: '/school',
      component: () =>
                import('../views/school/index'),
      name: '学校介绍',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/school/details',
      component: () =>
                import('../views/school/details/index.vue'),
      name: '学校正文', // 学校介绍-正文
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/school/roam',
      component: () =>
                import('../views/school/roam/index'),
      name: '漫游',
      roles: ['AppUser'],
      hidden: true
    }
  ]
}
